module.exports = __webpack_public_path__ + "img/download_logo.fa34230a.png";